import React from "react";
import PropTypes from "prop-types";
import { Image } from "@lululemon/ui-library";
import withStoryRenderer from "../with-story-renderer";

import styles from "./image-renderer.module.scss";

const ImageRender = ({ setIsMediaLoading, story }) => {
  const onImageLoad = () => {
    setIsMediaLoading(false);
  };

  return (
    <Image
      alt={story.alt}
      className={styles.reelImage}
      onLoad={onImageLoad}
      src={story.url}
    />
  );
};

const ImageRenderer = {
  renderer: withStoryRenderer(ImageRender),
  tester: (story) => ({
    condition: story.type === "image",
    priority: 4,
  }),
};

ImageRender.propTypes = {
  setIsMediaLoading: PropTypes.func.isRequired,
  story: PropTypes.shape({
    alt: PropTypes.string,
    url: PropTypes.string.isRequired,
    duration: PropTypes.number,
    cta: PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default ImageRenderer;
